import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function AdminLogin() {
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mk_token", data.token);
      localStorage.setItem("mk_admin_email", data.email);
      toast.success("Welcome");
      nav("/admin");
    } catch {
      toast.error(t.admin.loginError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 shadow-sm rounded-lg p-8" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-[#0891b2] rounded-full flex items-center justify-center">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <h1 className="font-display text-2xl text-slate-900">{t.admin.login}</h1>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-sm font-medium text-slate-700 mb-1.5 block">{t.admin.email}</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" />
          </div>
          <div>
            <Label className="text-sm font-medium text-slate-700 mb-1.5 block">{t.admin.password}</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit"
                  className="w-full bg-[#0891b2] hover:bg-[#ef4444] text-white h-11">
            {loading ? "..." : t.admin.signIn}
          </Button>
        </div>
      </form>
    </div>
  );
}
